export default {"src":"/_next/static/media/key_24.be95d5f0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};